const WordIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 64 64"
    >
      <defs>
        <linearGradient
          id="a"
          x1="5.56"
          y1="13.917"
          x2="26.441"
          y2="50.083"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2368c4" />
          <stop offset="0.5" stopColor="#1a5dbe" />
          <stop offset="1" stopColor="#1146ac" />
        </linearGradient>
      </defs>
      <title>Word_64x</title>
      <path
        d="M60.333,4H17.667A2.667,2.667,0,0,0,15,6.667V18l24,5.421L63,18V6.667A2.667,2.667,0,0,0,60.333,4Z"
        fill="#41a5ee"
      />
      <polygon
        points="63 18 15 18 15 32 39 37.442 63 32 63 18"
        fill="#2b7cd3"
      />
      <polygon
        points="15 32 15 46 39 52.347 63 46 63 32 15 32"
        fill="#185abd"
      />
      <path
        d="M17.667,60H60.333A2.667,2.667,0,0,0,63,57.333V46H15V57.333A2.667,2.667,0,0,0,17.667,60Z"
        fill="#103f91"
      />
      <rect width="64" height="64" fill="none" />
      <path
        d="M33,18.631V48.369a1.97,1.97,0,0,1-.045.452A2.606,2.606,0,0,1,30.378,51H15V16H30.378A2.622,2.622,0,0,1,33,18.631Z"
        opacity="0.2"
      />
      <path
        d="M34,18.76V46.24a3.734,3.734,0,0,1-1.163,2.71A3.682,3.682,0,0,1,30.278,50H15V15H30.278A3.755,3.755,0,0,1,34,18.76Z"
        opacity="0.1"
      />
      <path
        d="M33,18.652v27.7A2.632,2.632,0,0,1,30.378,49H15V16H30.378A2.632,2.632,0,0,1,33,18.652Z"
        opacity="0.2"
      />
      <path
        d="M32,18.652v27.7A2.641,2.641,0,0,1,29.359,49H15V16H29.359A2.642,2.642,0,0,1,32,18.652Z"
        opacity="0.1"
      />
      <rect width="64" height="64" fill="none" />
      <rect y="16" width="32" height="32" rx="2.667" fill="url(#a)" />
      <path
        d="M10.942,36.448q.078.617.1,1.076h.061q.036-.435.139-1.052t.2-1.039l2.805-12.1h3.626l2.9,11.919a17.166,17.166,0,0,1,.362,2.248h.049a17.17,17.17,0,0,1,.3-2.176l2.321-11.991h3.3L23.047,40.667H19.191L16.423,29.184q-.12-.5-.272-1.294t-.187-1.16h-.048q-.05.423-.188,1.257t-.223,1.233l-2.6,11.447H8.99l-4.1-17.334h3.36l2.526,12.124C10.835,35.707,10.889,36.037,10.942,36.448Z"
        fill="#fff"
      />
    </svg>
  )
}

export default WordIcon
